export default __webpack_public_path__ + "static/media/EMprint Regular.50c8142e.woff2";